// Shared Tailwind class strings for the Company Profile admin form controls.
// Extracted so branding sub-components can reuse identical styling.

export const inputClass =
  "w-full px-3 py-2 bg-surface-secondary border border-border-secondary rounded-lg text-content-primary placeholder:text-content-tertiary focus:outline-hidden focus:ring-2 focus:ring-brand-primary/50 text-sm";

export const labelClass = "block text-sm font-medium text-content-secondary mb-1.5";

export const textareaClass = `${inputClass} resize-none`;
